import React, { MouseEvent, ReactNode } from "react"
import { useParams } from "react-router-dom"

import { getParam } from "@shared/modules"

interface Props {
  shortsId: number
  title?: string
  className?: string
  children?: ReactNode
}

export default function WownetExecuteShortsLink({
  shortsId,
  title = "재생",
  className,
  children,
}: Props) {
  const { streamerName, scheduleId } = useParams<{
    streamerName: string
    scheduleId: string
  }>()

  const otp = getParam("otp")
  const isAdminEntry = !!otp

  // 어드민은 와우넷 계정이 아니라 ExecuteShorts를 거치면 실패하므로 숏폼 페이지를 직접 연다
  const url = isAdminEntry
    ? `/${streamerName}/${scheduleId}/shorts/${shortsId}?otp=${encodeURIComponent(
        otp,
      )}`
    : `https://www.wownet.co.kr/Common/Bcast/ExecuteShorts?id=${shortsId}`

  return (
    <a
      href={url}
      rel="noreferrer"
      title={title}
      className={className}
      onClick={(e: MouseEvent) => {
        e.preventDefault()

        const { availWidth, availHeight } = (window as any).screen
        const option =
          "fullscreen=yes,location=no,menubar=no,status=no,toolbar=no,directories"

        return window.open(
          url,
          title,
          `width=${availWidth},height=${availHeight},${option}`,
        )
      }}
    >
      {children ?? title}
    </a>
  )
}
